module.exports = __webpack_public_path__ + "967610c281acec8abe5b151cce77a49a.png";